export const TEXT_AREA_ROW_ONE = 1;
export const TEXT_AREA_ROW_TWO = 2;
export const TEXT_AREA_ROW_FOUR = 4;
export const TEXT_AREA_COL_FIFTY = 50;

// The maxlength property is artifically limited by the max number of characters SheerIDs
// metadata will store - 256.
export const MAX_LENGTH_256 = 256;

export const LIST_ITEM_NUMBER_THREE = 3;
